import { Flex, Text } from "@chakra-ui/react";
import { InfoIcon } from "../../icons/reader/InfoIcon";
import { t } from "i18next";

export function CollectibleIndicator() {
  return (
    <Flex flexDirection="row" gap="8px" alignSelf="center" alignItems="center">
      <InfoIcon boxSize="24px" color="neutral.400" />
      <Text
        color="neutral.400"
        fontSize="12px"
        lineHeight="150%"
        letterSpacing="0px"
      >
        {t("components.payments.purchaseRelease.collectibleIssue")}
      </Text>
    </Flex>
  );
}
